import * as type from './constant';

export const getDiscipline = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getDisciplineSuccess = (payload, month, selfRole = '') => ({
  type: type.GET_SUCCESS,
  payload,
  month,
  selfRole,
});

export const getDisciplineError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addDiscipline = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addDisciplineSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateDiscipline = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateDisciplineSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteDiscipline = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteDisciplineSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationDisciplineError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});
